// extracted by mini-css-extract-plugin
export default {"progress":"nWgQ8","totaliser-avatar-wrapper":"mjxmK","target":"CfUzF","value":"CLckY","raised":"OwedH"};